import GoBack from "../components/GoBack";
import CheckoutHeader from "../components/CheckoutHeader";
import {Navigate, Outlet, useLocation, useParams} from "react-router-dom";
import {useContext, useEffect, useState} from "react";
import Data from "../Data";
import AppContext from "../../../context";

const Checkout = ({ basePath = '' }) => {
    const { id } = useParams();
    const context = useContext(AppContext);
    const location = useLocation();
    if(!id) window.location.href = "/"

    const [experience, setExperience] = useState([]);

    useEffect(async () => {
        try {
            const experience = await Data.fetchExperienceById( { id})
            setExperience(experience.data)
        } catch (error) {
            window.location.href = "/"
        }
    }, []);

    const healthScreening = context.user?.healthScreening;
    const needsHealthScreening = !!context.domain?.healthScreeningEnabled && !!context.user && (
        !healthScreening?.completedAt || (healthScreening?.hasConcerns && !healthScreening?.clearedAt)
    );
    const onHealthScreeningStep = location.pathname.endsWith('/health-screening');

    return (
        <>
            <GoBack to={basePath ? `${basePath}/${id}` : "/"} label={`Back to ${experience.name}`} />

            <CheckoutHeader />

            {needsHealthScreening && !onHealthScreeningStep ?
                <Navigate to={`${basePath}/${id}/checkout/health-screening`} state={{ from: `${location.pathname}${location.search}` }} replace />
                : <Outlet />
            }
        </>
    )
}

export default Checkout
